'use client';

import { usePathname } from 'next/navigation';
import { usePromptTrigger } from '@/hooks/usePromptTrigger';

/**
 * Fires the prompt-counter increment for a programmatic-SEO page view.
 * pSEO covers three route groups per spec: /buildings, /apartments,
 * /articles. Deduped by pathname (each unique pSEO URL counts once).
 * Renders nothing.
 *
 * No return-URL is passed because the pSEO surface's review CTA
 * navigates to a generic `/review` (no building slug in scope).
 */
export function PseoPromptTrigger() {
  const pathname = usePathname();
  usePromptTrigger('pseo', pathname ?? '');
  return null;
}
